import React from 'react';

const SimpleFlex: React.FC = (props) => (
  <div style={{ display: 'flex' }}>
    {props.children}
  </div>
);

export default SimpleFlex;
